<template>
  <div class="wrap">
    <template v-if="course !== null">
      <div class="video_box">
        <div class="video_left">
          <div class="prism-player" id="J_prismPlayer"></div>
        </div>
        <div class="video_right">
          <div class="course_info">
            <div class="course_title two-line">
              {{ course.name }}
            </div>
            <div class="clock">{{ course.created_at | filterTime }}</div>
          </div>
          <div class="course_list">
            <template v-for="(item, index) in videoList">
              <div
                :class="['course_item', activeCourse === index ? 'active' : '']"
                :key="index"
                @click="clickVideoItem(index)"
              >
                {{ item.name }}
                <div
                  class="learn-tag"
                  v-if="item.videos_user && item.videos_user.status === 1"
                ></div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="course_intro">
        <div class="course_intro_title">课程简介</div>
        <div class="course_intro_cont">
          {{ course.introduction }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  fetchVideoDetail,
  fetchStartWatchVideo,
  fetchSetVideoProgress
} from "@/api/video";
export default {
  name: "Video",
  filters: {
    filterTime(val) {
      return val;
    }
  },
  data() {
    return {
      player: null,
      videoList: [],
      course: null,
      recordTimer: null,
      activeCourse: 0
    };
  },
  mounted() {
    const { id } = this.$route.query;
    fetchVideoDetail({
      course_id: id
    }).then((res) => {
      const { code, data } = res;
      if (code === 200) {
        const { course, video_list } = data;
        const { now_video_id } = course;
        this.course = course;
        this.videoList = video_list;
        let selectCourseIndex = 0;

        video_list.map((elem, index) => {
          if (elem.id === now_video_id) {
            selectCourseIndex = index;
          }
        });
        this.$nextTick(() => {
          if (video_list.length) {
            this.selectVideo(selectCourseIndex);
          }
        });
      }
    });
  },
  methods: {
    //点击视频item进行播放
    clickVideoItem(index = 0) {
      const { activeCourse } = this;
      if (index === activeCourse) return;
      //   const videoItem = videoList[index];
      //   const { videos_user } = videoItem;
      this.selectVideo(index);
    },
    //选中第几个视频播放
    selectVideo(index = 0) {
      const { videoList } = this;
      const videoItem = videoList[index];
      const { id, image, video_url, learn_at } = videoItem;
      this.initPlayer(video_url, image, learn_at);
      fetchStartWatchVideo({
        video_id: id
      });
      this.activeCourse = index;
    },
    //定时发送观看记录
    initTimerRecord() {
      const { activeCourse, videoList } = this;
      let activeVideoId = videoList[activeCourse].id;
      if (this.recordTimer === null) {
        this.recordTimer = setInterval(() => {
          let currentTime = this.player.getCurrentTime();
          fetchSetVideoProgress({
            video_id: activeVideoId,
            status: 0,
            second: parseInt(currentTime)
          });
        }, 2000);
      }
    },
    //清除定时记录
    clearTimerRecord() {
      if (this.recordTimer !== null) {
        clearInterval(this.recordTimer);
        this.recordTimer = null;
      }
    },
    //视频播放结束给后台发送
    getVideoEnd() {
      const { activeCourse, videoList } = this;
      let activeVideoId = videoList[activeCourse].id;
      videoList[activeCourse].videos_user = {
        status: 1
      };
      this.videoList = videoList;
      fetchSetVideoProgress({
        video_id: activeVideoId,
        status: 1,
        sencond: 0
      });
    },
    initPlayer(source, cover, seek_second = 0) {
      let { player } = this;
      if (player !== null) {
        player.dispose();
      }

      let skinLayout = [
        { name: "bigPlayButton", align: "cc" },
        {
          name: "H5Loading",
          align: "cc"
        },
        { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
        { name: "tooltip", align: "blabs", x: 0, y: 56 },
        { name: "thumbnail" },
        {
          name: "controlBar",
          align: "blabs",
          x: 0,
          y: 0,
          children: [
            { name: "playButton", align: "tl", x: 15, y: 12 },
            { name: "timeDisplay", align: "tl", x: 10, y: 7 },
            { name: "volume", align: "tr", x: 5, y: 10 },
            { name: "fullScreenButton", align: "tr", x: 10, y: 12 }
          ]
        }
      ];
      let playerOptions = {
        id: "J_prismPlayer",
        width: "100%",
        height: "100%",
        autoplay: false,
        source,
        cover,
        isLive: false,
        skinLayout,
        rePlay: false,
        liveRetry: 3,
        waitingTimeout: 30,
        disableSeek: true
      };
      player = new Aliplayer(playerOptions);

      let seeked = false;
      player.on("canplay", (ev) => {
        console.log(ev, "canplay");
        if (!seeked) {
          seeked = true;
          player.seek(seek_second);
        }
      });
      //视频由暂停恢复为播放时触发
      player.on("play", (ev) => {
        console.log(ev, "play");
        this.initTimerRecord();
      });
      //结束播放
      player.on("ended", (ev) => {
        console.log(ev, "ended");
        this.clearTimerRecord();
        this.getVideoEnd();
      });
      //暂停
      player.on("pause", (ev) => {
        console.log(ev, "pause");
        this.clearTimerRecord();
      });

      this.player = player;
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
